import { render } from "./index.vue?vue&type=template&id=654bc98b&scoped=true&ts=true"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"

import "./style.scss?vue&type=style&index=0&id=654bc98b&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654bc98b"]])

export default __exports__